module.exports = __webpack_public_path__ + "static/media/biostor.829c65b5.png";